module.exports = __webpack_public_path__ + "img/Annie_Home_Page_Image.998c2b2a.jpg";